import { css } from "@emotion/react";
import background from '../../assets/imgs/background.jpg';

export const styleGlobal = css`
  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    border: 0;
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
    appearance: none;
  }

  body {
    max-width: 100vw;
    max-height: 100vh;
    height: 100vh;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  input {
    transition: all 0.2s ease-out;
  }
`;